var _path, _path2, _path3, _path4, _path5, _path6, _path7, _ellipse, _ellipse2, _ellipse3, _ellipse4, _ellipse5, _ellipse6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMmsBottle(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 132,
    height: 166,
    viewBox: "0 0 132 166",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M77.0786 145.218C61.9394 159.5 21.9543 158.983 0.500853 144.951L0.850586 44.6074C28.8249 46.1931 45.6569 47.6548 77.4283 44.8743L77.0786 145.218Z",
    fill: "#F1F4F8",
    stroke: "#91A2BD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.40344 37.0783C1.92095 39.2942 1.38089 41.0889 1.22761 44.6085C30.8064 47.1117 47.4785 47.327 77.4281 44.8741C77.4387 41.8562 75.1845 39.2077 70.6643 37.3058L5.40344 37.0783Z",
    fill: "#F1F4F8",
    stroke: "#91A2BD"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M68.4182 32.3939L68.4011 37.2979L10.6849 37.0967L10.702 32.1927L6.1752 32.177L6.27776 2.753C6.9295 1.23974 7.72483 0.745034 9.30349 0.500135L70.0376 0.711815C71.6391 0.901886 72.1816 1.44631 72.6703 2.9844L72.5677 32.4084L68.4182 32.3939Z",
    fill: "#F1F4F8",
    stroke: "#91A2BD"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.33768 81.9655L11.4236 81.9728L13.608 87.3554L13.7017 87.3558L15.9236 81.9885L18.0095 81.9958L17.9816 89.9957L16.341 89.99L16.3592 84.783L16.2928 84.7828L14.2044 89.9435L13.0873 89.9396L11.035 84.7449L10.9686 84.7447L10.9504 89.9712L9.3098 89.9655L9.33768 81.9655ZM19.4031 82.0006L21.489 82.0079L23.6734 87.3905L23.7671 87.3909L25.989 82.0236L28.0749 82.0308L28.047 90.0308L26.4064 90.0251L26.4245 84.8181L26.3581 84.8178L24.2698 89.9786L23.1526 89.9747L21.1004 84.78L21.034 84.7798L21.0158 90.0063L19.3752 90.0006L19.4031 82.0006ZM33.8002 84.3516C33.7701 84.0364 33.6368 83.7911 33.4004 83.6158C33.1641 83.4405 32.8428 83.3522 32.4365 83.3507C32.1605 83.3498 31.9273 83.388 31.7369 83.4655C31.5465 83.5403 31.4003 83.6453 31.2983 83.7804C31.1989 83.9154 31.1488 84.0689 31.1482 84.2408C31.1425 84.384 31.1721 84.5091 31.2368 84.6161C31.3041 84.7231 31.3962 84.8159 31.5132 84.8944C31.6301 84.9703 31.7653 85.0372 31.9187 85.095C32.0722 85.1503 32.2361 85.1977 32.4104 85.2374L33.1286 85.4118C33.4772 85.4911 33.7972 85.5964 34.0884 85.7276C34.3796 85.8588 34.6317 86.0199 34.8445 86.2107C35.0574 86.4016 35.222 86.6261 35.3383 86.8843C35.4572 87.1425 35.5173 87.4383 35.5188 87.7717C35.5145 88.2612 35.388 88.6853 35.1393 89.0438C34.8933 89.3997 34.5382 89.6758 34.0739 89.8721C33.6123 90.0658 33.056 90.1615 32.405 90.1593C31.7591 90.157 31.197 90.0561 30.7185 89.8565C30.2426 89.6569 29.8713 89.3627 29.6044 88.9737C29.3401 88.5822 29.2025 88.0986 29.1915 87.523L30.8282 87.5287C30.8455 87.797 30.9215 88.0213 31.0563 88.2014C31.1937 88.379 31.3768 88.5137 31.6057 88.6057C31.8372 88.695 32.0987 88.7402 32.3904 88.7412C32.6768 88.7422 32.9257 88.7014 33.1369 88.6188C33.3507 88.5362 33.5165 88.4209 33.6342 88.2729C33.7519 88.1249 33.8111 87.9545 33.8118 87.7618C33.8124 87.5821 33.7595 87.4309 33.6532 87.3081C33.5495 87.1854 33.3962 87.0807 33.1933 86.994C32.9931 86.9074 32.7473 86.8284 32.4559 86.7571L31.5856 86.5353C30.9117 86.3689 30.38 86.1105 29.9906 85.7602C29.6012 85.4099 29.4088 84.9392 29.4135 84.348C29.4126 83.8636 29.543 83.4409 29.8046 83.0798C30.0689 82.7188 30.4306 82.4375 30.8896 82.236C31.3486 82.0344 31.8698 81.9347 32.4532 81.9367C33.0469 81.9388 33.5648 82.0422 34.0068 82.2468C34.4514 82.4515 34.7967 82.7353 35.0429 83.0981C35.289 83.4609 35.4152 83.8807 35.4213 84.3572L33.8002 84.3516Z",
    fill: "#91A2BD"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M22.0462 102.082C5.28932 98.1804 8.73764 103.593 1.75654 109.348L1.664 135.901C6.49458 128.766 9.13976 124.702 19.8757 123.387C33.4663 129.132 40.8448 128.508 53.7656 123.505C41.5475 120.436 38.8031 105.984 22.0462 102.082Z",
    fill: "#FFBFC5"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M61.38 103.667L71.2418 88.2349L73.1254 88.996L72.9821 130.114L61.2919 128.942L58.299 121.764L64.01 106.694L61.38 103.667Z",
    fill: "#FFBFC5"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M64.4766 81.0438L68.609 85.9623L67.0975 86.7115L62.2132 81.0359L63.7523 72.3649L71.3035 70.505L73.91 80.3222L75.3952 87.1176L69.3687 84.456L68.6261 81.0583L65.2455 76.8969L64.4766 81.0438Z",
    fill: "#FF808C"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 94.4735,
    cy: 142.72,
    rx: 10.5356,
    ry: 6.88863,
    transform: "rotate(-8.59965 94.4735 142.72)",
    fill: "#FFBFC5"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 120.262,
    cy: 145.41,
    rx: 10.5356,
    ry: 6.88863,
    transform: "rotate(6.03387 120.262 145.41)",
    fill: "#FFBFC5"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 97.7155,
    cy: 156.497,
    rx: 10.5356,
    ry: 6.88863,
    transform: "rotate(-10.1786 97.7155 156.497)",
    fill: "#FFBFC5"
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 73.4023,
    cy: 155.686,
    rx: 10.5356,
    ry: 6.88863,
    fill: "#FFBFC5"
  })), _ellipse5 || (_ellipse5 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 75.8334,
    cy: 155.686,
    rx: 10.5356,
    ry: 6.88863,
    fill: "#FFBFC5"
  })), _ellipse6 || (_ellipse6 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 96.0942,
    cy: 124.89,
    rx: 10.5356,
    ry: 6.88863,
    fill: "#FFBFC5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMmsBottle);
export default __webpack_public_path__ + "static/media/mms-bottle.4811f1aabbd82ab91387fd77d96c2ad6.svg";
export { ForwardRef as ReactComponent };